import PerfectScrollbar from 'perfect-scrollbar';

var ps;

if($('.js-scroll-longrid').height() > 0) {
	ps = new PerfectScrollbar('.js-scroll-longrid', {
		wheelSpeed: 0.2,
		wheelPropagation: true,
		minScrollbarLength: 180
	});
}


// WEBPACK FOOTER //
// ./src/js/pages/longrid/longrid-scroll.js